import { memo, useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import * as accountsService from '@/services/accounts';
import * as tokenService from '@/services/token';

interface Props {
  children: React.ReactNode;
  register?: boolean;
}

const PrivateRoute = ({ children, register }: Props) => {
  const { hash } = useParams<{ hash: string }>();

  const [renderComponent, setRenderComponent] = useState(false);

  const loadApplication = useCallback(async () => {
    const refreshed = await tokenService.isPossibleRefresh();

    if (refreshed) {
      setRenderComponent(refreshed);
      return;
    }

    accountsService.loginAccounts(setRenderComponent, register ? hash : undefined);
  }, [hash, register]);

  useEffect(() => {
    if (!tokenService.checkIsAuthenticated()) {
      loadApplication();
    } else {
      setRenderComponent(true);
    }
  }, [loadApplication]);

  if (!renderComponent) return null;

  return <>{children}</>;
};

export default memo(PrivateRoute);
